import { useState, useEffect, useRef } from 'react';

const useDidMountEffect = (func, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) func();
        else didMount.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

/**
 * Loads an image source and keep track of isLoaded and error states.
 *
 * @param {string} src
 * @returns {[boolean, boolean]}
 */
function useImageLoader(src) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!src) {
            return;
        }
        const image = new Image();
        image.onload = () => setIsLoaded(true);
        image.onerror = () => setError(true);
        image.src = src;
        return () => {
            image.onload = null;
            image.onerror = null;
        };
    }, [src]);

    return [isLoaded, error];
}

export { useDidMountEffect, useImageLoader };
